/*@jsxRuntime automatic @jsxImportSource react*/
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
function _createMdxContent(props) {
  const _components = Object.assign({
    h2: "h2",
    p: "p",
    code: "code",
    pre: "pre",
    blockquote: "blockquote",
    a: "a"
  }, _provideComponents(), props.components);
  return _jsxs(_Fragment, {
    children: [_jsx(_components.h2, {
      children: "Animations"
    }), "\n", _jsxs(_components.p, {
      children: ["CSS animations with ", _jsx(_components.code, {
        children: "@keyframes"
      }), " aren't scoped to a single component but you still don't want them to be global to avoid name collisions. This is why we export a ", _jsx(_components.code, {
        children: "keyframes"
      }), " helper which will generate a unique instance that you can use throughout your app:"]
    }), "\n", _jsx(_components.pre, {
      children: _jsx(_components.code, {
        className: "language-react",
        children: "// Create the keyframes\nconst rotate = keyframes`\n  from {\n    transform: rotate(0deg);\n  }\n\n  to {\n    transform: rotate(360deg);\n  }\n`;\n\n// Here we create a component that will rotate everything we pass in over two seconds\nconst Rotate = styled.div`\n  display: inline-block;\n  animation: ${rotate} 2s linear infinite;\n  padding: 2rem 1rem;\n  font-size: 1.2rem;\n`;\n\nrender(\n  <Rotate>&lt; 💅🏾 &gt;</Rotate>\n);\n"
      })
    }), "\n", _jsxs(_components.blockquote, {
      children: ["\n", _jsxs(_components.p, {
        children: ["Keyframes are not supported by ", _jsx(_components.code, {
          children: "react-native"
        }), ". Instead, use the ", _jsxs(_components.a, {
          href: "https://stackoverflow.com/questions/50891046/rotate-an-svg-in-react-native/50891225#50891225",
          children: [_jsx(_components.code, {
            children: "ReactNative.Animated"
          }), " API"]
        }), "."]
      }), "\n"]
    }), "\n", _jsxs(_components.p, {
      children: ["Keyframes are lazily injected when they're used, which is how they can be code-split, so you have to use ", _jsxs(_components.a, {
        href: "/docs/api#css",
        children: ["the ", _jsx(_components.code, {
          children: "css"
        }), " helper"]
      }), " for shared style fragments:"]
    }), "\n", _jsx(_components.pre, {
      children: _jsx(_components.code, {
        className: "language-javascript",
        children: "const rotate = keyframes``\n\n// ❌ This will throw an error!\nconst styles = `\n  animation: ${rotate} 2s linear infinite;\n`\n\n// ✅ This will work as intended\nconst styles = css`\n  animation: ${rotate} 2s linear infinite;\n`\n"
      })
    }), "\n", _jsxs(_components.blockquote, {
      children: ["\n", _jsxs(_components.p, {
        children: ["This used to work in v3 and below where we didn't code-split keyframes. If you're upgrading from v3, make sure that all your shared style fragments are using the ", _jsx(_components.code, {
          children: "css"
        }), " helper!"]
      }), "\n"]
    })]
  });
}
function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = Object.assign({}, _provideComponents(), props.components);
  return MDXLayout ? _jsx(MDXLayout, Object.assign({}, props, {
    children: _jsx(_createMdxContent, props)
  })) : _createMdxContent(props);
}
export default MDXContent;
